import styled from 'styled-components'
import Textfield from 'syf-component-library/ui/atoms/Textfield'
import Stepper from 'syf-component-library/ui/patterns/Stepper'
import query from 'syf-component-library/const/mediaQueries'

export const TextfieldWithMargin = styled(Textfield)`
  margin-bottom: 35px;
`

export const LastTextfield = styled(Textfield)`
  margin-bottom: 25px;
`

export const HorizontalProgressStepBar = styled(Stepper)`
  padding-top: 30px;
  padding-left: 0;
  margin: 10px auto 25px;
  @media ${query.greaterThanMedium} {
    width: 450px;
  }
`
